<template>
    <div class="flex gap-px bg-gray-400 w-max">
        <slot />
    </div>
</template>
